import { BaseModel, RecursivePartial } from "@models/base";
import { VzParam } from "../params";

export class WorkflowTriggerActionDef extends BaseModel {
    type!: number;
    name?: string;
    description?: string;
    params?: VzParam[];

    constructor(json?: RecursivePartial<WorkflowTriggerActionDef>) {
        super(json);
        this.parseUnreadCounters(json || {});
    }

    parse(json: RecursivePartial<WorkflowTriggerActionDef>): WorkflowTriggerActionDef {
        super.parse(json);
        this.parseUnreadCounters(json);
        return this;
    }

    private parseUnreadCounters(json: RecursivePartial<WorkflowTriggerActionDef>): void {
        WorkflowTriggerActionDef.assignFields<WorkflowTriggerActionDef>(this, json, ['type', 'name', 'description']);
        WorkflowTriggerActionDef.assignClassArrays<WorkflowTriggerActionDef>(this, json, { params: VzParam });
    }
}
